import { render, staticRenderFns } from "./MotorItem.vue?vue&type=template&id=19c0c061"
import script from "./MotorItem.vue?vue&type=script&lang=js"
export * from "./MotorItem.vue?vue&type=script&lang=js"
import style0 from "./MotorItem.vue?vue&type=style&index=0&id=19c0c061&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports